export default __webpack_public_path__ + "media/images/small-info-afbf164670750a8f60bea59886ebce4e.png";